/**
 * Error discriminators carried in the `?error=` search param on the forgot-password page
 * when another auth flow redirects the user there.
 */
export const FORGOT_PASSWORD_ERROR = {
  EXPIRED_CODE: 'expired-code'
} as const;

/**
 * Reason discriminators carried in the `?reason=` search param on the reset-password page
 * when the reset was started by another auth flow rather than by the user.
 */
export const RESET_PASSWORD_REASON = {
  PASSWORD_RESET_REQUIRED: 'password-reset-required'
} as const;

/** reCAPTCHA Enterprise action label for the forgot-password / resend-code flow. */
export const FORGOT_PASSWORD_RECAPTCHA_ACTION = 'forgot_password';

/** reCAPTCHA Enterprise action label for sending an email-verification code. */
export const EMAIL_VERIFICATION_RECAPTCHA_ACTION = 'email_verification';

/**
 * Search param set on the login page after an address is verified, so login can
 * confirm it. A persistent alert rather than a toast: it carries the instruction
 * the user needs while filling the form in.
 */
export const EMAIL_VERIFIED_QUERY_PARAM = 'emailVerified' as const;

export type ForgotPasswordError = (typeof FORGOT_PASSWORD_ERROR)[keyof typeof FORGOT_PASSWORD_ERROR];

/** A `RESET_PASSWORD_REASON` value carried in the reset-password `?reason=` search param. */
export type ResetPasswordReason = (typeof RESET_PASSWORD_REASON)[keyof typeof RESET_PASSWORD_REASON];
